import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import {
   ArrowSquareDown,
   CheckSquare,
   FileArrowUp,
   Paragraph,
   RadioButton,
   Textbox,
   TextT
} from '@phosphor-icons/react'

const icons = {
   checkbox: CheckSquare,
   dropdown: ArrowSquareDown,
   file: FileArrowUp,
   input: Textbox,
   paragraph: Paragraph,
   radio: RadioButton,
   text: TextT
}

const FormElementRow = ({ name, icon }) => {
   const Icon = icons[icon || 'text']

   return (
      <div className="flex items-center gap-4 h-10 text-white border-b border-solid border-neutral-100/10 text-xs last:border-b-0 scale-90">
         <Icon size={16} weight="bold" className="opacity-50" />
         <div>{name}</div>
      </div>
   )
}

FormElementRow.propTypes = {
   name: PropTypes.string.isRequired,
   icon: PropTypes.string.isRequired
}

const FormsFeature = ({ active }) => {
   const [visible, setVisible] = useState(false)

   useEffect(() => {
      if (active) {
         setTimeout(() => {
            setVisible(true)
         }, 200)
      } else {
         setVisible(false)
      }
   }, [active])

   return (
      <div className="w-full h-full">
         <div
            className={classNames(
               'flex flex-col gap-4 absolute top-[15%] left-[15%] w-[70%]'
            )}>
            <div
               className={classNames(
                  'rounded-lg overflow-hidden shadow-[0px_10px_30px_rgba(0,0,0,0.3)] transition-all duration-700',
                  visible ? 'translate-x-0 opacity-100' : 'translate-x-8 opacity-0'
               )}>
               <img
                  className="w-full"
                  src="/assets/custom/communities/images/features/forms/1.png"
                  alt="Forms"
               />
            </div>
            <div
               className={classNames(
                  'rounded-lg overflow-hidden shadow-[0px_10px_30px_rgba(0,0,0,0.3)] transition-all duration-700 delay-100 opacity-0',
                  visible ? 'translate-x-0 opacity-50' : 'translate-x-8 opacity-0'
               )}>
               <img
                  className="w-full"
                  src="/assets/custom/communities/images/features/forms/2.png"
                  alt="Forms"
               />
            </div>
         </div>

         <div
            className={classNames(
               'absolute top-[10%] sm:top-[30%] -right-[10%] w-[55%] rounded-3xl overflow-hidden shadow-[0px_10px_30px_rgba(0,0,0,0.3)] border border-solid border-neutral-100/10 bg-neutral-900/95 transition-all duration-700 delay-200 scale-75 sm:scale-100',
               visible ? 'translate-x-0 opacity-100' : 'translate-x-10 opacity-0'
            )}>
            <div className="w-full flex flex-col px-2 py-2">
               <FormElementRow name="Text Explanation or Information" icon="text" />
               <FormElementRow name="Single-line Text Input" icon="input" />
               <FormElementRow name="Paragraph Text Input" icon="paragraph" />
               <FormElementRow name="Multiple Choice" icon="radio" />
               <FormElementRow name="Checkboxes" icon="checkbox" />
               <FormElementRow name="Dropdown" icon="dropdown" />
               <FormElementRow name="File Upload" icon="file" />
            </div>
         </div>
      </div>
   )
}

FormsFeature.propTypes = {
   active: PropTypes.bool.isRequired
}

export default FormsFeature
